'use client';

import * as React from 'react';
import { MenuIcon } from 'lucide-react';

import { Button } from '@workspace/ui/components/button';
import { ScrollArea } from '@workspace/ui/components/scroll-area';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger
} from '@workspace/ui/components/sheet';

import { DocsSidebar } from '~/components/docs/docs-sidebar';

export function DocsMobileNav(): React.JSX.Element {
  const [open, setOpen] = React.useState(false);

  return (
    <div className="sticky top-[var(--marketing-header-height)] z-30 -mx-4 flex border-b bg-background/95 px-4 py-3 backdrop-blur supports-[backdrop-filter]:bg-background/80 sm:-mx-6 sm:px-6 lg:hidden">
      <Sheet
        open={open}
        onOpenChange={setOpen}
      >
        <SheetTrigger asChild>
          <Button
            variant="outline"
            className="marketing-secondary-control h-11 w-full justify-start gap-2"
          >
            <MenuIcon className="size-4" />
            Browse documentation
          </Button>
        </SheetTrigger>
        <SheetContent
          side="left"
          className="marketing-docs-mobile w-[min(88vw,360px)] gap-0 p-0"
        >
          <SheetHeader className="border-b px-5 py-4 text-left">
            <SheetTitle>Documentation</SheetTitle>
            <SheetDescription>
              Product guides and Lumnis MCP setup.
            </SheetDescription>
          </SheetHeader>
          <ScrollArea className="min-h-0 flex-1 px-4 py-5">
            <DocsSidebar
              onNavigate={() =>
                window.requestAnimationFrame(() => setOpen(false))
              }
            />
          </ScrollArea>
        </SheetContent>
      </Sheet>
    </div>
  );
}
